module.exports = {
  "Gattaran_optimization_yGvp_jOAe": "确认",
  "Gattaran_form_tLLN_yhWQ": "我们将自动填充经常使用的联系人信息，你可以点击编辑内容",
  "Gattaran_V1__YaIb": "在线",
  "Internal_Tools_0523_GtzK_ZoJh": "该商家当前无符合条件的活动，请引导商家参加自营销活动",
  "FoodOpB_Translation_Maestra_Accounts_ktyA": "Maestra accounts",
  "FoodOpB_management_Special_rules_PdhA": "特殊规则",
  "FoodB_Commision_Add_MPEf": "添加",
  "FoodB_tagging_You_chose_OMGB": "您选择了无效商机原因为：店铺不存在，必需填写照片！",
  "FoodB_collection_11_digits_QhYs": "11位数字，不能有空格",
  "FoodOpB_management104_Coordinator_endx": "协调员",
  "Internal_Tools_CRM_afvI_xcXS": "仅支持尺寸为750*360px的图片",
  "Gattaran_transformation__TnQQ": "关联新签约主体",
  "FoodB_0_Please_upload_ziBz": "请上传通话记录截屏",
  "FoodB_phrase__NpWx": "仅展示近{{number}}个月的已结束营销活动",
  "FoodOpB_1_Expired_rTXx": "已过期",
  "Gattaran_0_Clerk_tends_QpMA": "店员倾向联系方式",
  "FoodB_Show_Store_Direct_GuJM": "商户直签",
  "FoodOpB_Management_Appeals_foxk": "申诉",
  "FoodB_optimization__bdZL": "请上传5M以内且不小于200*200的图片，支持jpg、png格式。",
  "Gattaran_management_NjMN_zyWQ": "已计划·{{date}}",
  "Gattaran_opt_swMT_sNcV": "营销-套餐",
  "Gattaran_20240401_rbqe_PoaI": "该问卷必须填写",
  "FoodC_sales_Confirmation_mTGd": "确认",
  "FoodB_v1_Sources_of_DsXR": "信息来源",
  "Gattaran_transformation__LMJQ": "主体已签约。追加门店请在加塔兰后台完成",
  "Internal_Tools_App2_HwDq_KOci": "周二",
  "Internal_Tools_App_Bruh_XLwk": "周环比率",
  "FoodB_1__gcdX": "活动数据",
  "FoodD_payout_Account_Type_YmVW": "账户类型",
  "Gattaran_statusbar2_eoSG_yEDD": "已核准",
  "Gattaran_record_IcKI_Jklz": "编辑拜访",
  "FoodB_V2_Illegal_companies_pXwb": "非合法公司",
  "FoodOpB_1_New_visits_HXsz": "新建拜访",
  "CS_Aftersale_Wrong_meal_gNCe": "错餐",
  "Gattaran_202406_eUIt_lfFS": "已完成",
  "Gattaran_0__Yqcw": "当前区域没有门店",
  "FoodB_audit_Store_Information_ryuV": "门店信息编辑审核",
  "Gattaran_form_xrZg_zpSi": "结果",
  "Fintech_Credit_part__mMjm": "筛选项",
  "FoodC_c_Completed_djPp": "已结束",
  "FoodB_list_Recently_launched_IWDa": "最近上线时间",
  "Gattaran_add_vitO_CCPh": "Picture coverage>=60%",
  "FoodOpB_1_Seven_days'_LZwW": "七日拜访",
  "Gattaran_202406_lujp_fWRq": "任务描述",
  "FoodB_1__IhgO": "更新至:{{time}}",
  "Gattaran_0__VRqN": "已加载全部门店",
  "FoodOpB_1_Close_visit_ttxh": "关闭拜访确认",
  "Gattaran_side__MIpl": "星期五",
  "Gattaran_optimization_oRge_RkDM": "拜访任务完成度·{{month}}",
  "Gattaran_Optimization_zZhD_VHmE": "点击查看商家地址并支持导航",
  "FoodB_SMS__promotion_EKZy": "免配送",
  "Internal_Tools_App_CwAV_dUXQ": "反馈",
  "Gattaran_opt_cWad_xQOF": "问题订单",
  "FoodB_audit_Review_process_vGtV": "审核流程，是否确定？",
  "FoodB_collection_idCIF_qqcc": "idCIF",
  "FoodB_0_WhatsApp_dmMD": "WhatsApp",
  "FoodD_Name_October_WGkU": "十月",
  "Gattaran_opt_RltV_fDyM": "特价餐(非套餐）",
  "Internal_Tools_App_wlIb_LduM": "油站电话",
  "FoodB_Show_Tax_payment_xfxh": "纳税方式（全国）",
  "Gattaran_Visit_Visiting_Process_KFJZ": "拜访过程评分",
  "FoodB_V1_uXrr_bWox": "你可以在此管理或重置筛选项",
  "Gattaran_KPI4_Sjnd_VzaZ": "商家提醒",
  "Gattaran_function__iTSm": "版本",
  "FoodB_list_B_Burn_LIiU": "B2C burn",
  "FoodB_2_Store_XkLQ": "商家",
  "FoodB_0622_Select_up_QXDl": "最多选择2个门店",
  "Gattaran_202406_jhpc_QSnv": "参考信息",
  "FoodB_tagging_You_chose_aZCG": "您选择了无效商机原因为：停止营业，当前位置距离店铺大于{{distance}}，请检查！",
  "Internal_Tools_App_zuDQ_HAZF": "请输入数字，小数点后限两位",
  "Gattaran_management_sGBh_ExWD": "营业时间",
  "FoodB_resivion_Feedback_to_QmQU": "请反馈给你的上级进行更新",
  "FoodB_0926__Jfhv": "无相应状态的营销活动",
  "Internal_Tools_App_vLxA_pkbn": "添加图片",
  "Gattaran_0410_hDTJ_vhKk": "点击此处查看绩效详情",
  "FoodB_0907__jtsj": "无诊断内容",
  "Gattaran_0_Need_to_uMbb": "需要与KP确认",
  "Gattaran_Visit_Evaluation_eRDU": "自我评估",
  "Gattaran_optimization_mtXy_iWsc": "最少选择2个选项",
  "Internal_Tools_App_qYbb_MgvG": "系统异常，请稍后重试",
  "Gattaran_0_Salesmen_tend_hFQf": "店员倾向联系时间",
  "FoodB_Show_Foreign_DIMEX_LKxF": "外国人DIMEX",
  "Gattaran_0_Agree_gCQO": "同意",
  "Internal_Tools_App_mZpF_DDAl": "价格趋势",
  "Internal_Tools_App_vFxG_UzcO": "线索状态",
  "FoodOpB_Management_High_similarity_lnFn": "存在高相似度店铺",
  "FoodB_Launch_DR_Passport_JChW": "DO-护照",
  "Gattaran_Visit_Change_1_LYvR": "改变1",
  "FoodB_0905__yxOa": "与上一统计周期相比，单量不变",
  "Gattaran_v1_Whrf_ZdCg": "未报名，请前往商家平台进行操作",
  "Gattaran_0_Is_the_dYmK": "商家菜单是否易读",
  "Internal_Tools_App_qWbF_LiGR": "位置校准",
  "Internal_Tools_App_kqPi_MVIx": "提示",
  "Gattaran_Homepage__bYLT": "首页",
  "Gattaran_0_The_end_KvBf": "结束时间必须大于开始时间",
  "Gattaran_Top_Qwud_sgUf": "2.系统每月2号和17号会刷新一次商家的DiDi Top标识",
  "Internal_Tools_App2_VFPY_BWgZ": "周日",
  "Gattaran_AlertV1_ADYi_okAH": "知道了",
  "Gattaran_V1_DJia_IZfI": "完成度",
  "FoodB_0_SMS_yOMB": "短信",
  "Gattaran_0_KP_Tendency_hgOB": "KP倾向联系时间",
  "FoodD_Name_February_bMVM": "二月",
  "Gattaran_addded_wrMT_Smyq": "提前结束活动",
  "FoodB_list_Name_of_dxYm": "销售姓名",
  "Internal_Tools_App_wjZO_XKBK": "近{{week}}周",
  "Internal_Tools_App_OMWw_QlWM": "激励中",
  "Gattaran_V1__ZtqD": "查看营销教程",
  "Gattaran_202406_WOhb_WMrp": "你好，你收到了高优先级的的相关任务，请查看",
  "Internal_Tools_App_MIpi_aqcx": "我的油站",
  "Gattaran_opt_ZoVs_IpEA": "支持发起签约、查看签约状态、查看失败原因等",
  "FoodOpB_management_Indicators_BzjD": "指标",
  "Gattaran_management_wjiE_tOBX": "你好，{{name}}。随函附上访问期间达成的协议摘要：",
  "Internal_Tools_App_cuEn_PzWj": "编辑导航地址",
  "FoodD_AccountInfoCollection_Got_it_QvNt": "知道了",
  "Gattaran_Visit_Formula_pre_iaaI": "公式=（准备工作评分+拜访过程评分+拜访后评分）/3*100%",
  "Gattaran_Top_pXow_LHcq": "1.当商家“完单量”“B责取消率”“用户评分”达到一定标准（不同城市标准不同，详见商家详情页面），则商家会被识别为DiDi Top",
  "Gattaran_Optimization_WwkH_amBP": "点击可以查看更多联系人，并拨打电话",
  "FoodB_Launch_DR_Temporary_BQFH": "DO-临时居留证",
  "FoodB_0830__BIGT": "本月拜访次数",
  "FoodB_time_No_permission_Xxyy": "无权限",
  "Internal_Tools_App_Rmvn_wSCd": "油站ID",
  "FoodOpB_1_Information_gathering_pIHo": "信息收集",
  "FoodB_2_Online_visit_OLuR": "线下",
  "Internal_Tools_0510_EoqC_dJrN": "未设置营业时间",
  "Gattaran_V1__WcTv": "菜品合格率",
  "FoodOpB_1_Visit_Details_fMYD": "拜访详情",
  "FoodOpB_results_No_key_kUbv": "无关键目标联系方式",
  "Gattaran_opt_ybdn_zFnD": "电话信息缺失，待补充",
  "FoodB_0919__flip": "上架菜品数",
  "FoodB_audit_Audit_process_asoS": "审核流程，且在审核完成前不可申请签约，是否确定？",
  "Internal_Tools_App_pFzG_uAQv": "该线索已失效",
  "Gattaran_202406_JcEF_NsbI": "商家名称",
  "Internal_Tools_App2_xWJN_ZxWx": "计划删除后将无法恢复",
  "Gattaran_Collection__cRDE": "最近搜索",
  "FoodB_202204_Number_of_yYUn": "差评订单数",
  "Gattaran_0_Add_Image_xyvl": "增加图片覆盖",
  "Gattaran_MSGCenter__JYjL": "请输入",
  "FoodB_Show_Savings_uvSS": "储蓄",
  "Gattaran_opt_aDBh_QgeX": "开店检查项",
  "Gattaran_form_hRvn_xomV": "电话是必填的",
  "FoodOpB_1_Visiting_hours_yAJS": "拜访时间",
  "FoodB_leads_Artificial_labcategory_UNzu": "人工标记品类",
  "Internal_Tools_App_csEG_rLit": "油站税号",
  "FoodB_list_Store_ID_GNUR": "门店ID",
  "Gattaran_0__EDtg": "开启",
  "Internal_Tools_App2_PcSB_DsIH": "周三",
  "Gattaran_0_App_Opertends_voML": "App操作员倾向联系方式",
  "FoodB_system_offline_revV": "线下",
  "FoodB_address_Submission_cfyI": "提交",
  "FoodOpC_Notifications_Are_you_DIlk": "是否确认删除？",
  "FoodOpB_manage_Details_IfVh": "详情",
  "FoodB_0926__bEjZ": "无未开始的营销活动",
  "FoodB_CL_Individuals_VUHt": "个人",
  "Gattaran_202406_REeT_tgTh": "任务维度",
  "FoodB_list_Brand_Name_pGTc": "品牌名称",
  "Gattaran_transformation__IetC": "创建新签约主体",
  "Gattaran_optimization_dYfW_WtFS": "完成度",
  "Gattaran_management_LaXK_Gsyq": "我的拜访",
  "FoodOpB_management_Actual_integral_xbDD": "实际积分",
  "Gattaran_optimation_Gchd_SmWz": "忽略",
  "Gattaran_opt_dswD_GkVn": "拜访信息",
  "Gattaran_Optimization_Gbsd_oiSb": "门店PK",
  "FoodB_0905__qppX": "与上一统计周期相比，减少{{number}}单",
  "Gattaran_management_yrfV_Wxnn": "过期拜访·{{num}}",
  "FoodD_Name_December_Ykas": "十二月",
  "Internal_Tools_App2_ZJkV_KWsU": "过期拜访·{{num}}",
  "Gattaran_jumpnewstore_mLmx_PSph": "完成新成长任务，获得额外流量",
  "FoodD_Name_June_sECU": "六月",
  "Gattaran_opt_hEOr_vnKB": "点击编辑商机基础信息",
  "Internal_Tools_0523_RFQp_wVYb": "可注册",
  "Gattaran_side__EEqj": "星期六",
  "Gattaran_Visit_jKcM_bAxG": "达成交易",
  "Gattaran_0_Name_of_ZnnR": "店员姓名",
  "Gattaran_management_pWnp_hrQt": "概要",
  "Gattaran_20240401_CGBK_NFyI": "必填问卷",
  "FoodOpB_Translation_Foreigner_hMcE": "外国人卡",
  "Gattaran_0_App_operators_aRSs": "App操作员倾向联系时间",
  "Internal_Tools_App_ttnY_JnyP": "主要联系人已更新",
  "Gattaran_optimization_TyQA_JkkG": "刷新",
  "FoodB_0919__RZJo": "正常完单数",
  "Gattaran_form_JZlB_BGSo": "请输入真实原因",
  "Gattaran_management_SBaW_IDnY": "邮件详情",
  "Gattaran_opt_SrLe_Wnrt": "较上期减少{{change}}",
  "Gattaran_202311_qwtt_tkJb": "已筛选出Hotlist的门店，请高优跟进",
  "Gattaran_management_iAiq_CSuB": "已有相同时间计划，请直接编辑",
  "FoodD_Name_March_cqIc": "三月",
  "Gattaran_form_UTaZ_WTAv": "信息尚未保存，确认要离开吗？",
  "Gattaran_Visit_Please_choose_kUmR": "请选择被陪访人",
  "FoodOpB_app_Need_for_inMl": "需要进一步谈判",
  "Gattaran_V1__ccGl": "过去30天",
  "FoodB_Part1_Store_Name_jrHD": "门店名称",
  "Internal_Tools_App_rdCa_GHLw": "纬度：{{lat}}",
  "Internal_Tools_App2_VhOQ_uUiq": "目的：{{objective}}",
  "Internal_Tools_CRM_hPLY_Zkpg": "集团",
  "FoodB_Show_Subject_Information_RFOj": "主体信息",
  "Gattaran_0__dPUc": "最多加载{{amount}}家门店，点击查看更多",
  "Gattaran_opt2_aPIx_GJQw": "营业平台",
  "Gattaran_0_Remind_store_lgTS": "提醒商家上线",
  "FoodB_0920__QnBO": "不满足诊断规则",
  "Gattaran_transformation__LRHh": "关联已有签约主体",
  "Gattaran_opt_XUCE_CQDw": "编辑线下经营信息",
  "FoodOpB_10_Order_volume_WNmq": "订单量",
  "FoodB_resivion_Skip_qpSD": "跳过",
  "Internal_Tools_CRM_NNrK_cPfT": "营业时间",
  "Gattaran_0_Promotional_materials_vvdT": "宣传材料",
  "FoodOpB_CRM_Card_holder_NfIL": "持卡人证件号码",
  "Internal_Tools_App_enKj_BRtS": "价格",
  "Internal_Tools_App_oOXF_fLkh": "确认",
  "FoodB_I_UlHM_KKLT": "活动订单量",
  "Gattaran_0__sGZg": "欢迎给我们分享关于Explorer的反馈。",
  "Internal_Tools_App2_TIxP_DqBp": "备注",
  "FoodB_Show_Aliens_Residence_creU": "外国人居留卡",
  "Gattaran_Optimization_PLZM_XBgE": "点击跳转DiDi Food到商家页面",
  "Internal_Tools_App_Mldc_EJhb": "更多",
  "Internal_Tools_App_mKHz_CpID": "获取当前位置经纬度",
  "Gattaran_V1_MQcd_ixfe": "查看全部可报名的商家",
  "FoodOpB_app_Need_to_eGSb": "协商SUP",
  "FoodB_0905__ccXH": "诊断周期",
  "Gattaran_0__XIOS": "请输入店铺数量",
  "Gattaran_form_zKmF_tGJc": "确认",
  "Gattaran_jumpnewstore_UjqV_XVxm": "新店成长",
  "Gattaran_202311_NpGG_CLsO": "返回距离该门店{{distance}}内的结果",
  "Gattaran_optimation_shNo_Pflo": "拜访表单页面意外退出，点击“重新打开”以再次进入上一次停留的页面。",
  "Internal_Tools_App_vOMm_KIrz": "退出登录",
  "MRider_Version_payment_method_rQSI": "支付方式",
  "Gattaran_function__Comd": "更新内容",
  "FoodB_V2_No_bank_plEI": "无银行账号信息",
  "FoodB_Show_Final_Tax_XQQi": "最终缴税金额",
  "Gattaran_jumpnewstore_WVcO_LmBU": "详情查看",
  "Gattaran_add_XrAW_datb": "Available dishes>=5",
  "Gattaran_management_DvoF_BCCh": "拜访任务",
  "FoodOpB_CRM_Type_of_fbmW": "持卡人证件类型",
  "Gattaran_Collection__YHYF": "推荐",
  "FoodB_V2_Failure_to_sQaD": "未达合作门槛",
  "FoodB_Show_Tax_payment_Dbuz": "纳税方式（当地）",
  "Gattaran_transformation__PgJQ": "主体信息",
  "Internal_Tools_App_AsKa_smrq": "选择油品种类",
  "FoodOpB_Translation_BD_with_Jqpl": "BD与餐厅门脸合影",
  "Internal_Tools_App_TwQH_yOgX": "分行",
  "FoodB_0622_Contrast_jVys": "对比",
  "FoodOpB_Translation_Enter_CCI_YyDK": "请输入CCI账号",
  "FoodOpB_CRM_Taxpayer_full_tMpR": "纳税人全名（当地）",
  "Gattaran_v1_HLQw_cJDz": "点击展示具体商家经营时间明细",
  "FoodB_supplement_No_data_jUGB": "没有数据",
  "Gattaran_limit_NvlC_czdh": "无权限，仅门店负责销售可操作",
  "Gattaran_transformation__pglh": "保存并返回",
  "Gattaran_management_dWbz_DrVf": "线下拜访完成度·{{month}}",
  "Internal_Tools_App_IadN_oKZj": "银行账号",
  "FoodOpB_management_Weight_sGBg": "权重",
  "FoodOpB_CO_Provisional_Tax_ZpCx": "临时缴税金额",
  "Internal_Tools_App_uXeN_VtKY": "城市",
  "Gattaran_V1__SttS": "营销",
  "Gattaran_V1_qsGI_Ulsk": "数据加载中，大概需要几秒",
  "Gattaran_schedule_ajzu_twuj": "数量超出提示",
  "Internal_Tools_App2_yIFi_UEbZ": "周一",
  "FoodB_0926__pZyK": "无进行中的营销活动",
  "FoodB_Show_ID_Card_BrxO": "身份证",
  "FoodB_030_zOTR_tsWu": "我的商圈",
  "Gattaran_withdraw_Ofwd_NgCY": "撤销后本次申请流程结束，后续需要重新提交签约申请，请谨慎操作！",
  "Internal_Tools_App_SKgO_wHcV": "财务联系人电话",
  "Gattaran_V1_YDbp_akEe": "所有有效营销活动",
  "Internal_Tools_CRM_CJvi_BeaN": "ERP系统",
  "Internal_Tools_App_SvGD_UfGw": "经营数据",
  "FoodD_payout_Company_Registration_zoVW": "公司注册号",
  "FoodOpB_1_Visiting_Status_rbMX": "拜访状态",
  "FoodB_audit_Distance_between_BRSw": "新旧店铺距离差异",
  "Others_boarding_City_choice_ryMd": "城市选择",
  "FoodB_Launch_DR_Foreigner_gXpW": "DO-外国人证",
  "Gattaran_0__uLBv": "请输入订单量",
  "FoodB_210811_No_tax_QkcN": "无税务文件",
  "Internal_Tools_CRM_RyhE_fFHt": "主要联系人邮箱",
  "Internal_Tools_App_ujvr_QghX": "油站图片（最多上传{{amount}}张）",
  "Gattaran_V11_fscy_YDKX": "达标标准",
  "Gattaran_form_rnAn_flyZ": "必须输入KP电话或照片任意一项",
  "FoodB_collection_Taxpayer_Postal_guUo": "纳税人邮政编码（全国）",
  "Gattaran_20240401_LMVL_IKxX": "退出APP",
  "FoodOpB_tagging_You_chose_obli": "您选择了无效商机原因为：停止营业 ，当前位置距离店铺大于{{distance}}，请检查！ ",
  "FoodB_management_Business_hours_VLnY": "平日营业时间",
  "Gattaran_Visit_Personal_Goals_FDcw": "个人目标/学习",
  "Internal_Tools_App_Hrci_mwCF": "油站地址",
  "Gattaran_mgt_Search_Results_pFNV": "搜索结果",
  "Gattaran_mgt_Indicates_that_nHWP": "表示未达标",
  "Gattaran_V1__hUDQ": "服务",
  "FoodB_0_Please_upload_BZIQ": "请上传聊天记录截屏",
  "FoodB_Show_Current_NJqK": "活期",
  "Gattaran_0_Clerk_nZnx": "店员",
  "FoodB_CL_power_of_KgHH": "委托书",
  "Gattaran_mgt_Sort_QiOq": "排序",
  "FoodB_list_KP_Phone_qQCQ": "KP电话",
  "Gattaran_AlertV1_CYCs_NjzG": "点击这里你可以查看需要你重点关注的商家",
  "Gattaran_jumpnewstore_lspf_nNoN": "点击跳转新店成长模块，查看任务详情，助力商家完成相关任务",
  "FoodB_V2_dLkl_pbiF": "客户端版本低，请更新版本再操作",
  "FoodB_management_Store_association_coYB": "关联门店",
  "Gattaran_0_Are_there_ouHJ": "是否有其他店铺",
  "FoodD_Storefront_YFcS_cnUy": "Storefront",
  "Internal_Tools_App_WpuB_Tmys": "是",
  "Gattaran_0_Edit_contacts_nCLZ": "编辑联系人",
  "Gattaran_function__fALF": "取消",
  "Gattaran_Feedback__urHD": "低",
  "Internal_Tools_App2_NTbv_hmkk": "无拜访信息",
  "Gattaran_opt2_UTsL_QVlH": "其他",
  "Gattaran_Visit_Total_score_iZIW": "总得分",
  "Gattaran_202406_xlNL_HNSV": "文件类型信息建议通过GTR-销售任务管理页面上传",
  "FoodB_2_AOP_VVZV": "AOP",
  "FoodB_V1_raHO_jXSF": "本月R burn/GMV",
  "FoodB_diagnosis_Items_qQOR": "菜品",
  "FoodB_field_No_need_hToz": "不需要",
  "FoodB_2__YqWB": "拒绝原因",
  "Internal_Tools_CRM_nTMX_ElyI": "油站精确位置",
  "FoodOpB_Translation_Passport_jpaq": "护照",
  "Gattaran_Visit_Pre_visit_NLpf": "准备工作评分",
  "Internal_Tools_App_RxZj_EZmI": "本周",
  "Gattaran_Visit_Tracking_KfAS": "追踪",
  "Internal_Tools_App_QNzF_fvmK": "合同状态",
  "Gattaran_add_MyGp_GdUb": "avatar",
  "FoodOpB_1_Visit_today_hLhX": "今日拜访",
  "Gattaran_function__PRSL": "下载",
  "Internal_Tools_App2_drNi_CAgA": "周四",
  "Gattaran_0_Consistent_with_CiFN": "与线下价格一致",
  "Gattaran_0_Buy_gifts_dbKh": "买赠",
  "Gattaran_statusbar2_QzkZ_tHWY": "草稿中",
  "Gattaran_0_No_match_Tgve": "免配",
  "Internal_Tools_App_UIXX_nKyD": "最多可查看360天内的数据",
  "Gattaran_opt_ikuS_aRyl": "拜访结果",
  "FoodC_revision_Less_meal_pHwq": "少餐反馈",
  "Gattaran_Visit_Rating_after_lruO": "拜访后评分",
  "FoodOpB_Translation_Please_add_mxTD": "请添加上传以下三种文件中的任意一种即可：法定代表人授权书、商业登记、更新状态证书",
  "FoodOpB_management_Corresponding_fractions_QlGf": "对应分数",
  "FoodB_CL_Simple_company_JBRG": "简单公司",
  "Gattaran_0_Package_fweo": "套餐",
  "Internal_Tools_App_SruZ_Bhfa": "精确位置",
  "Internal_Tools_Ops_ouPX_WYmu": "油站编号",
  "Gattaran_Visit_After_a_ILbF": "拜访后",
  "FoodB_0622_Store_management_ztNB": "门店经营",
  "Gattaran_202406_SQiw_AXZW": "销售任务管理",
  "Gattaran_tag_mnOh_LlIQ": "活动即将到期",
  "Gattaran_V1__zewR": "菜单",
  "Gattaran_Collection__twwL": "可以在这里查看全部拜访记录",
  "Internal_Tools_App_pynL_unFB": "商户类型",
  "Gattaran_V11_DQdi_QRqK": "未达标",
  "Gattaran_mgt_Performance_data_ymwM": "绩效数据",
  "FoodB_field_Needs_IbzB": "需要",
  "Internal_Tools_CRM_APZA_BShD": "基础信息",
  "Internal_Tools_App_NkMV_mnZQ": "通过地图定位",
  "Gattaran_0_Visit_Information_hzgb": "拜访信息",
  "Gattaran_opt_KdGX_oUmM": "签约",
  "Gattaran_center__TkvV": "暂无消息",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "首位必须是1，必须输入11位",
  "Gattaran_Visit_APP_Review_nbGn": "APP审查",
  "Gattaran_form_nFaJ_bcHw": "联系人",
  "Internal_Tools_App_AFZd_haQA": "集团",
  "FoodB_collection_Enter_idCIF_NeUD": "请输入idCIF",
  "Internal_Tools_App_XqPY_lOag": "支付方式",
  "Gattaran_side__sOcs": "星期二",
  "FoodB_audit_The_strings_NPFx": "点击确定后会发起{{strings}}审核流程，且在审核完成前不可申请签约，是否确定？",
  "Gattaran_Visit_View_Visit_eZdF": "查看拜访计划",
  "GDriver_B_apbe_dntZ": "油站名称",
  "Internal_Tools_App_lbMG_ilBX": "服务设施",
  "Gattaran_v1_guwq_yflY": "点击展示招商活动详情",
  "FoodB_0707_Lifted_off_tnXl": "已下架",
  "FoodB_0113_ZcCF_NbjE": "你可在此添加拜访计划",
  "Gattaran_0__VQyB": "我的门店",
  "FoodB_Show_Special_residence_ezfV": "外国人特殊居留证",
  "FoodB_audit_Review_Opportunity_ZQHk": "商机基础信息编辑审核",
  "FoodB_audit_Click_OK_Zfsf": "点击确定后会发起",
  "FoodB_time_All_day_TIsU": "全天歇业",
  "FoodB_0622_Sales_KRCg": "销量",
  "Internal_Tools_CRM_MKcO_yldx": "线索来源",
  "Gattaran_opt_JcLo_plhe": "在线时长",
  "FoodOpB_1_Fill_in_QvuH": "填写拜访计划",
  "Internal_Tools_CRM_fHSX_VjzW": "精确位置错误，请重新选择",
  "Gattaran_0_Increase_in_yvaq": "增加营业时长",
  "Gattaran_202406_wmja_Unkw": "任务执行人",
  "Internal_Tools_App_sOCx_HZNJ": "今日营业时间",
  "Gattaran_opt_jfHC_vGTC": "本月完单",
  "Internal_Tools_CRM_eqgV_MrAE": "请输入正确的的经纬度",
  "Internal_Tools_App2_oKVZ_QNJf": "拜访计划已创建成功",
  "FoodB_0322_gUpY_CIHG": "当前筛选条件下无匹配店铺",
  "FoodB_list_Apply_for_RxQn": "申请签约",
  "FoodB_field_Is_you_uNye": "是否需平台申报全国的税",
  "Gattaran_invalid_Itxj_ruEf": "已剔除无效商机，如需查找无效商机请自行筛选或使用搜索功能",
  "Internal_Tools_App_ROpA_rFNd": "财务联系人邮箱",
  "Gattaran_0_Using_Store_khfo": "使用商家端设备",
  "Internal_Tools_CRM_hQxQ_PeNI": "油站类型",
  "Gattaran_0_Full_gift_nhuV": "满赠",
  "FoodB_b_Source_of_qGPd": "活动来源",
  "FoodB_0_Please_upload_roTo": "请上传邮件记录截屏",
  "Gattaran_0_App_Operator_HJuu": "App操作员电话",
  "Gattaran_mgt_Search_History_DIkw": "搜索历史",
  "Gattaran_center__IJmL": "消息",
  "Gattaran_schedule_eLPM_Vdmp": "继续",
  "Internal_Tools_App_xIAG_xcRt": "单次最长查询范围是30天",
  "Gattaran_form_HAwV_aOvm": "拜访结果",
  "FoodOpB_Translation_General_accounts_NeVu": "一般账户",
  "Internal_Tools_App_wStM_yTkP": "油站位置：{{Address}}",
  "Gattaran_side__EgXn": "星期一",
  "FoodOpB_CRM_Taxpayer_Address_ptqR": "纳税人地址（当地）",
  "Gattaran_Visit_Management_and_JkoC": "管理和后续步骤",
  "Gattaran_Visit_Select_a_YAtw": "请选择陪访日期",
  "Gattaran_center__vsus": "点击了解详细内容",
  "Gattaran_management_cYvq_XraB": "无拜访信息",
  "Gattaran_transformation__njrW": "签约主体名称",
  "Gattaran_Visit_New_escort_zHov": "新建陪访",
  "Gattaran_uikey_qCBF_mlck": "Commercial Offering",
  "FoodB_new1_Name_similarity_gepH": "名称相似度",
  "Gattaran_V1_JVoT_DmFC": "查看",
  "Gattaran_opt_qiBN_MCGQ": "撤销",
  "Gattaran_202311_xiHr_yFIi": "推荐",
  "Gattaran_optimization_Tore_pnsp": "系统发现你的定位已发生变化，是否刷新当前页面？",
  "Gattaran_form_hGfR_KtSN": "添加拜访结果",
  "Gattaran_management_gqoK_XBEn": "今天",
  "Gattaran_202406_TbgT_vOga": "是否确认提交？一旦提交不可修改",
  "Gattaran_V1_IUgS_cyMV": "商家可报名",
  "FoodB_optimization_Contract_No_GvBj": "合同编号",
  "Gattaran_202406_lKot_vsVa": "在GTR系统销售任务管理模块下载文件",
  "Gattaran_function__DqfF": "版本更新",
  "FoodB_switch_yJQj_DSir": "是否授权平台100%补贴活动",
  "Groceries_brand_bqwY_mhhq": "创建成功",
  "Internal_Tools_App_dIhB_OKLN": "设置为主要联系人吗？",
  "FoodB_Wordings_iyFv_fDmW": "补充说明",
  "Gattaran_schedule_yPeR_CtMc": "当日线下拜访计划超过{{number}}条，将默认为你选择前{{number}}个拜访计划生成路线",
  "FoodOpB_Home_Mandate_vafk": "任务",
  "FoodB_management_Queries_dawh": "查询",
  "FoodB_optimization_Stimulate_contact_xSSH": "倾向联系方式",
  "FoodB_0919__mVqa": "出餐超时数",
  "Internal_Tools_CRM_pWry_BgtM": "请选择",
  "Gattaran_202406_NcUB_dVhS": "任务创建时间",
  "FoodOpB_center_Action_MexV": "操作",
  "Internal_Tools_App_fTOH_ETfJ": "请输入",
  "Gattaran_opt2_egxV_xfoW": "问题订单率",
  "Gattaran_mgt_Display_content_IlcO": "展示内容",
  "Gattaran_0__BHKX": "地图",
  "Gattaran_management_IDJi_lZyx": "{{amount}}今日拜访计划，查看你的规划",
  "Internal_Tools_CRM_bNjK_DISV": "偏好拜访方式",
  "FoodB_Show_Company_Registration_VcVV": "公司注册号（CJ）",
  "FoodOpB_OpsTasks_Off_GCPV": "关闭",
  "Gattaran_mgt_Gap_BnAE": "差距",
  "Gattaran_20230803_WsGI_IIwM": "目标",
  "Gattaran_20240401_LxEe_Ydha": "问卷调研",
  "Gattaran_0__tYzF": "当前区域没有门店，拖动地图加载更多",
  "Gattaran_Visit_Objection_management_WIuV": "异议管理",
  "FoodOpC_jiatalan_Deleted_successfully_GeGq": "删除成功",
  "FoodB_collection_5_6_hFrc": "5-6位数字",
  "Gattaran_opt_lDge_zZTn": "点击跳转地图导航；点击电话标志查看KP及商家联系方式",
  "Gattaran_management_icdH_hGfu": "详情",
  "Gattaran_0_Training_DM_ozrH": "培训DM或App操作员",
  "Others_platform_Tax_documents_jEir": "税务证件",
  "Internal_Tools_App_sfLV_YhZV": "离开",
  "Gattaran_0_Maximum_number_pgYM": "每种角色最多新建一个人",
  "FoodB_CL_Letter_of_EmKs": "委托书-执照照片",
  "FoodB_0113_ELbg_zfBg": "你可在此查看门店KP信息",
  "FoodB_Analysis_Old_people_fwCy": "老客",
  "Gattaran_0__iUtr": "邮箱",
  "FoodOpB_Translation_Natural_persons_fVFa": "自然人",
  "FoodB_0905__wwdP": "分项权重",
  "FoodC_improve__ByLg": "与预期不符",
  "FoodOpB_Tool_Set_FrCO": "未设置",
  "Gattaran_v1_fltf_eBMP": "已报名，请在商家平台查看详细信息",
  "Gattaran_0_Purpose_of_COzp": "拜访目的",
  "FoodB_0905__vMsv": "与上一统计周期相比，增加{{number}}单",
  "FoodOpB_Tool_Completed_MjfD": "已完成",
  "FoodOpB_1_Visit_tomorrow_ptjT": "明日拜访",
  "FoodOpB_system_DiDi_ALAy": "DiDi合作",
  "Gattaran_202406_hoAo_HpXw": "收到的（{{N}}）",
  "Gattaran_0_KP_tendency_YwDf": "KP倾向联系方式",
  "FoodB_collection_Taxpayer_ID_zntM": "纳税人身份证（CURP）",
  "FoodB_V2_No_store_ahBo": "无门店税号",
  "FoodB_tagging_You_have_ssrJ": "您选择了无效商机原因为：非零售店铺，必需填写照片或KP电话任意一项！",
  "Gattaran_schedule_qPDb_CTYm": "生成路线",
  "Gattaran_202311_JOTQ_efhW": "无推荐拜访",
  "Gattaran_0_App_Operator_PFUQ": "App操作员姓名",
  "FoodB_Show_Special_Tax_Eidl": "特殊纳税号码",
  "Internal_Tools_App_SHoN_atyR": "油站",
  "Gattaran_0_Self_marketing_BQlO": "自营销",
  "Gattaran_Optimization_VLZp_WhPs": "查看商家地址",
  "FoodB_leads_KP_Phone_hCUe": "KP电话 2",
  "FoodOpB_APP_Visit_vdze": "拜访",
  "FoodB_Wordings_DKwT_wbfI": "请说明您的选择理由，您的反馈对我们非常重要，有助于我们改进！",
  "FoodB_new1_Similarity_ItET": "相似度",
  "FoodB_V2_iZpC_KKcK": "分享诊断报告给商家",
  "FoodD_h5_Single_quantity_lrNq": "完单量",
  "FoodOpB_1_New_Visiting_tIni": "新建拜访计划",
  "Internal_Tools_App_HdHN_rUqy": "油站服务",
  "Gattaran_statusbar2_HKvC_dhsJ": "已签约",
  "Internal_Tools_App_yiaL_Hsph": "推荐上传油站照片",
  "Internal_Tools_App_zYXv_Uwsb": "经营状态",
  "FoodD_Name_July_RJXL": "七月",
  "FoodOpB_bill_Status_doqj": "状态",
  "FoodOpB_1_Closed_ieMb": "已关闭",
  "Internal_Tools_CRM_uCms_fFPv": "主要联系人电话",
  "Gattaran_V1__xaNO": "取消率",
  "FoodC_intostore_Store_Coupon_kHwh": "商家券",
  "Gattaran_mgt_Filter_WuXS": "筛选",
  "Internal_Tools_App2_TpmY_bfhb": "拜访",
  "Gattaran_opt_nyES_OcBw": "订单",
  "Gattaran_opt_slKF_FRuu": "超时未接单",
  "FoodB_0905__dSOH": "店铺诊断",
  "Gattaran_opt_xozr_fXeD": "本月R Burn",
  "FoodB_collection_12_or_woYo": "12或者13位数字符，必须大写，不能有空格",
  "FoodB_Launch_DR_Military_Rxvi": "DO-军人证",
  "Internal_Tools_App_BBZi_lqDC": "保存",
  "FoodOpB_CO_Store_official_VsRU": "商户官网",
  "Gattaran_Collection__oNFU": "使用Google Maps导航",
  "Gattaran_20240401_iGPg_djYX": "去填写",
  "Gattaran_0__eeft": "全部门店",
  "FoodD_Name_April_UHuR": "四月",
  "Internal_Tools_App_xBYh_JJGr": "距离",
  "FoodOpB_systemV2_Corresponding_coefficient_nVdO": "对应系数",
  "FoodD_Name_January_lhYr": "一月",
  "Gattaran_opt_oUrr_YTIV": "签约状态条",
  "FoodOpB_tool_Category_main_aHZl": "主营品类",
  "Internal_Tools_App_YNFM_WUWd": "筛选",
  "Internal_Tools_App_EMFl_vDCu": "州注册号",
  "Gattaran_0_Role_QDBu": "角色",
  "Gattaran_V20__THMR": "商户等级",
  "Gattaran_form_xJkV_MADh": "备注",
  "Gattaran_0__ypdc": "在此区域加载",
  "Gattaran_management_adiS_UvoW": "无拜访任务",
  "Gattaran_Page_Distance_jPzG": "距离",
  "Gattaran_0_Menu_optimization_hWWT": "菜单优化",
  "Gattaran_form_MLcA_tPgo": "该字段是必填字段",
  "Gattaran_202406_wGfZ_ewxp": "任务执行团队",
  "Internal_Tools_CRM_MiAT_UkNG": "取消",
  "FoodB_0905__zFVs": "总体权重",
  "FoodB_management_Name_of_EjQd": "上级姓名",
  "Gattaran_mgt_Check_the_Zyhr": "查看参与考核的商家列表",
  "Gattaran_KPI_System_performance_cQiV": "系统绩效系数",
  "Gattaran_Visit_Change_2_mNNS": "改变2",
  "Gattaran_Optimization_AFCF_zMMS": "支持给联系人拨打电话",
  "FoodB_0707_High_prices_fBsL": "高价",
  "Gattaran_0_Select_Contact_UrRS": "选择联系人",
  "Internal_Tools_App_oLpX_dbCU": "今天",
  "FoodB_0921__isZD": "合格率",
  "Internal_Tools_CRM_yMUu_NPxu": "请输入",
  "Gattaran_transformation__zjbG": "签约主体ID",
  "bill-manage---no_auth": "暂无权限",
  "Internal_Tools_CRM_roQc_QSuD": "联系电话",
  "Gattaran_202311_XTsd_OBZL": "距离该门店{{distance}}",
  "Internal_Tools_App_OKLc_fuyL": "近{{day}}天",
  "Gattaran_form_wrkw_ybam": "目的",
  "FoodB_audit_Similarity_check_cQEP": "相似度校验",
  "FoodOpB_CRM_Taxpayer_full_fzhk": "纳税人全名(全国)",
  "Internal_Tools_App_pdgP_UCoK": "通过手动输入定位",
  "Internal_Tools_0523_djkV_XXks": "已注册活动列表",
  "FoodB_field_Do_you_mhOz": "是否需平台申报当地的税",
  "Internal_Tools_App2_WfdX_XUIO": "已完成",
  "FoodB_0820__bVDh": "高优门店",
  "Gattaran_0__ztLy": "反馈",
  "FoodB_management_Role_yLYi": "角色",
  "FoodB_CL_Traditional_companies_cQhK": "传统公司",
  "Internal_Tools_App_sneY_mCvo": "财务联系人姓名",
  "Gattaran_0__Auzn": "拖动地图加载更多门店",
  "Internal_Tools_App_cbRv_idqO": "线索信息",
  "FoodOpB_CRM_Taxpayer_Tax_xOmZ": "纳税人税号 （当地）",
  "FoodD_Name_August_cjQS": "八月",
  "FoodOpB_system_DiDi_XcUY": "DiDi经营",
  "Gattaran_management_WjPM_jAvI": "发送协议给商家",
  "Gattaran_opt_klQH_BPVb": "商机信息",
  "Gattaran_statusbar2_HSiT_INfG": "审批通过",
  "Gattaran_v2_meyK_ACyX": "支持跳转至{{DiDi_Top}}",
  "Internal_Tools_App2_FAVe_GEuM": "编辑计划",
  "Gattaran_202406_lNdD_KvZI": "商家任务({{N}})",
  "Gattaran_V1_HNYI_VwLG": "商家未报名",
  "FoodB_collection_Tax_Classification_uJHT": "税制分类（全国）",
  "Gattaran_202406_FRwK_cCbx": "我的任务",
  "Internal_Tools_App_FCxp_ADxG": "营业时间",
  "Gattaran_0_Marketing_activities_qANU": "营销活动",
  "FoodB_CL_RUT_roUA": "RUT",
  "FoodB_optimization_Full_reduction_NlOa": "满减",
  "Gattaran_add_WtmN_hzJP": "Connectivity>60%",
  "FoodB_0327_ZGTe_zcKH": "点击这里可以切换城市",
  "Gattaran_0__NAOt": "请描述你的问题或建议并发送到下面的邮箱或直接通过D-Chat联系我们。",
  "Gattaran_0509_PLgH_VDtS": "前10热销菜",
  "Gattaran_optimization_deWd_ffjJ": "最终绩效完成度",
  "FoodB_V2_No_legal_QONX": "无法人身份证ID",
  "FoodB_Commision_Type_of_EIWZ": "商户类型",
  "Gattaran_mgt_Unqualified_Store_JeWr": "未达标商家",
  "FoodB_NewStore_Status_HphC": "状态",
  "Gattaran_20240401_kuua_DPLO": "暂时跳过",
  "FoodB_list_Store_Phone_tSWo": "门店电话",
  "Gattaran_opt2_kPIo_ZpuU": "自配送单量(每周)",
  "Gattaran_management_Associated_New_iDiy": "关联新门店",
  "Gattaran_202406_HnXs_yYCh": "任务状态",
  "Gattaran_form_wuYy_lqzb": "平台信息",
  "Gattaran_management_HgTV_cHfW": "添加计划",
  "Gattaran_jumppromo_ONbQ_nOEB": "营销数据看板",
  "FoodB_optimization_Label_nzNw": "标签",
  "FoodB_P0_cNyW_HkyE": "完单变化量",
  "FoodB_20230410_YNjt_xAWA": "优选好店",
  "Gattaran_optimization_MwZK_gJdn": "指标激励",
  "Internal_Tools_App_tpZf_wbHM": "主要联系人",
  "Internal_Tools_App2_XBvf_vJDB": "检查",
  "FoodB_list_Setting_Up_YlBy": "设置在线时长",
  "Gattaran_statusbar2_Pfzu_ihne": "审批中",
  "Gattaran_opt_SsHX_vUuN": "售罄取消",
  "Gattaran_schedule_saMI_wHLe": "可以一键生成线下拜访路线啦！",
  "Internal_Tools_App2_bcHq_KppB": "待拜访",
  "Gattaran_0_Merchant_activities_wwGb": "招商活动",
  "Gattaran_Translation_Alien_ID_IMja": "外国人身份证",
  "Internal_Tools_App_Prgi_JgdZ": "确认",
  "FoodB_V1_CLCC_nUuk": "创建拜访",
  "FoodB_I_Home_OrRo": "首页",
  "FoodB_collection_Taxpayer_Information_fQid": "纳税人信息查询",
  "Gattaran_202406_cPQJ_uCFE": "任务类型",
  "FoodOpB_information_The_selected_LyoI": "所选银行不支持结算",
  "FoodD_Name_September_Ezci": "九月",
  "FoodB_0_Mail_SUKZ": "邮件",
  "Internal_Tools_App_LlZj_XSVI": "创建拜访",
  "Gattaran_202406_ndOn_KPLE": "任务详情",
  "Gattaran_opt2_Nngy_DhyN": "审核状态已过期，此处无法查询。请联系相关产品负责人",
  "Gattaran_Visit_Accompanied_visitors_ZFNA": "被陪访人",
  "Internal_Tools_App2_BEqX_EVvQ": "周五",
  "Gattaran_0_Improved_Cancellation_KpWF": "改善取消率",
  "Gattaran_Visit_Before_visiting_VHLe": "拜访前",
  "Gattaran_mgt_Display_all_Yagb": "默认展示所有未达标的商家及其指标",
  "FoodB_CL_Amount_CLP_Tmnv": "金额（CLP）",
  "FoodOpB_CO_Not_applicable_WuPn": "不适用",
  "FoodD_supplement_Rules_RYAa": "规则",
  "Internal_Tools_App_qybY_jcAh": "ERP系统",
  "FoodB_tagging_You_chose_DSiT": "您选择了无效商机原因：停止营业，必需填写照片或KP电话任意一项！\t\n",
  "Gattaran_opt_cUSL_RSNr": "地图导航&查看联系方式",
  "Gattaran_form_YzJW_ggnb": "商家经营信息",
  "FoodB_0919__YKYU": "非营销",
  "Gattaran_202406_jIoA_BlIm": "展示维度",
  "Gattaran_management_hCqr_uwez": "编辑邮件",
  "Gattaran_0_Operating_channels_upHR": "每日订单",
  "Gattaran_AlertV1_FkFa_EQiG": "暂时没有符合条件的商家",
  "FoodB_V1_BEKq_hBNG": "已筛选：{{tag_name}}",
  "Gattaran_management_BjBQ_GVEr": "{{num1}}/{{num2}}线下拜访完成度·{{month}}",
  "Internal_Tools_App2_MoBn_DHqJ": "删除",
  "Gattaran_AlertV1_MmvI_acwe": "剩余{{date}}天",
  "Gattaran_mgt_Without_search_XVsz": "无搜索结果，可调整筛选条件后再次尝试",
  "Internal_Tools_App_GMMl_xksG": "银行名称",
  "FoodB_Launch_DR_ID_AnVk": "DO-身份证",
  "Gattaran_management_oCmv_JtTy": "滴滴协议",
  "FoodB_CL_Vista_Account_QcOm": "Vista账户",
  "Gattaran_BDapp_Rvoe_RUHw": "BD门户（普通）",
  "FoodB_I_onwf_oaQH": "活动销售额",
  "Internal_Tools_App_Qgai_eoNp": "品牌",
  "Gattaran_KPI_ioIq_fNJB": "该商家首次在线时间",
  "Gattaran_Feedback__dWQe": "处理人",
  "Internal_Tools_App_rOKe_yMwP": "ERP状态",
  "Gattaran_jumppromo_vqdm_KQKO": "点击跳转营销数据看板，查看更多数据详情",
  "Internal_Tools_App_gUvZ_AiZQ": "拜访信息",
  "FoodB_0_Please_upload_dcPG": "请上传短信记录截屏",
  "Internal_Tools_0510_DBOY_ADvH": "未设置节假日营业时间",
  "FoodB_CL_Add_any_egRn": "请添加上传以下三种文件中的任意一种即可：法定代表人授权书、圣地亚哥（或相关城市）商业登记、更新状态证书",
  "Internal_Tools_App2_lQcx_yrtq": "添加计划",
  "Gattaran_form_FtqP_caNF": "拜访目的",
  "Gattaran_Visit_Results_ftOU": "结果",
  "Gattaran_0_Improvement_of_TPKB": "改善差评率",
  "FoodB_0830__wEQD": "本月完单量",
  "Gattaran_side__vcvR": "星期日",
  "Internal_Tools_App_GiyX_Jwmf": "添加拜访记录",
  "Gattaran_opt_AGTs_VRUG": "较上期增加{{change}}",
  "Internal_Tools_CRM_qtMC_roJU": "油站",
  "Internal_Tools_App_LMjQ_TQFW": "当前位置距油站：{{Distance}}",
  "Gattaran_202406_iXbv_CcJq": "任务基础信息",
  "Internal_Tools_App2_ZjjL_OoOa": "详情",
  "FoodB_CL_Maximum_amount_oflZ": "单次最大扣费金额（CLP）",
  "Gattaran_Visit_Date_of_TyAN": "陪访日期",
  "Gattaran_management_nGle_XtpC": "商家邮箱",
  "Internal_Tools_App_vJec_vZqL": "Swift代码",
  "Internal_Tools_App_VzrE_Uvmn": "油站名称",
  "Gattaran_Visit_Getting_ready_zDyf": "准备工作",
  "Gattaran_management_IEaM_OfwD": "联系人称谓",
  "FoodB_I_QuSz_HsAZ": "营销力度",
  "Gattaran_mgt_No_performance_GzjE": "暂无绩效数据",
  "Internal_Tools_App_FiXW_DMEF": "拉新中",
  "Gattaran_0229_SpOD_JZZs": "可能是由于您在DiDi合作、线下、DiDi经营内选择了互斥的筛选条件。",
  "FoodB_audit_The_information_jxLV": "您提交的信息不满足",
  "FoodB_optimizing_Duplicate_Store_aBYS": "重复门店ID",
  "Gattaran_202406_QyVz_DlrH": "任务优先级",
  "Gattaran_Visit_Visit_process_dZws": "拜访过程",
  "Internal_Tools_App2_ALgE_nywC": "结果：{{result}}",
  "Gattaran_Top_gxPb_uTLM": "3.商家一旦成为DiDi Top，则会得到一定流量权益，对于提升单量大有益处，所以努力帮助你的商家成为DiDi Top吧",
  "Gattaran_transformation__sLrG": "当前主体下有商机在审核中，审核通过后可签约",
  "FoodOpB_1_There_may_scoc": "计划时间可能存在冲突，该日计划如下：",
  "Internal_Tools_App_TDqq_hkdP": "油品种类",
  "Gattaran_0_Create_new_Faau": "新建联系人",
  "FoodOpB_1_Are_you_sLNY": "确定关闭本次拜访？关闭后拜访失效不可录入",
  "Internal_Tools_0523_XvOO_ugWO": "已注册，查看详情",
  "Gattaran_management_lLpT_dFdN": "未拜访",
  "Gattaran_202406_CvwH_Obyc": "任务截止时间",
  "FoodOpB_results_The_key_HHMa": "关键目标不在店铺",
  "FoodOpB_1_A_recent_LtIi": "已有近期未完成的拜访计划，是否继续录入？",
  "Internal_Tools_App_skNg_IIIe": "否",
  "Internal_Tools_App_qOUi_WmVg": "纬度",
  "Gattaran_V20__eJGq": "商机等级",
  "Gattaran_optimization_qReN_wCHB": "本月的拜访任务已更新，立即查看",
  "Gattaran_form_rWtU_nHko": "请选择",
  "FoodB_optimization_Special_Meal_YtqD": "特价菜",
  "Gattaran_0_Prices_of_kkXs": "滴滴相对于线下菜单的价格",
  "Internal_Tools_App_sXad_CZPU": "地区和语言",
  "Gattaran_opt_AIBq_AcbH": "编辑商机信息",
  "Gattaran_form_MhMj_Wboc": "添加平台信息",
  "FoodOpC_backend_Urban_hhdx": "城市",
  "FoodOpB_app_Need_to_XZYr": "需要线下拜访",
  "Gattaran_opt_bWcH_ShAH": "添加计划",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "昨天",
  "Internal_Tools_App_cuvl_RIgb": "退出确认",
  "FoodB_030_fqBt_uzDV": "该城市缺少城市权限：{{City}}，请在Gattaran申请权限",
  "Gattaran_opt_CjOE_rGuI": "查看更多拜访信息",
  "Internal_Tools_CRM_lbMF_fwNr": "主要联系人姓名",
  "FoodOpB_Translation_Cash_accounts_fSLJ": "现金账户",
  "Fleet_tool_Search_sFMa": "搜索",
  "FoodOpB_tagging_Non_retail_JnDS": "不是一家餐厅",
  "Gattaran_0__diqD": "没有门店",
  "Internal_Tools_CRM_VRWr_pCnt": "普通销售",
  "Gattaran_Visit_Empathy_and_CvFh": "同理心和谈判初期",
  "Gattaran_0_Clerk_call_fhnx": "店员电话",
  "Gattaran_20240409_JERr_RtyH": "查看全部商家",
  "Gattaran_AlertV1_MVye_ihrr": "当前绩效系数",
  "FoodOpC_system_Business_hours_coEs": "营业时间",
  "Gattaran_form_TTAw_lJPb": "可输入备注作为补充信息",
  "Gattaran_mgt_Achievement_GuwU": "达标",
  "Gattaran_Visit_Business_feedback_Llza": "业务反馈对话",
  "FoodB_phrase__PWcd": "无已结束的营销活动",
  "Gattaran_opt_ZCLf_SEBU": "门店ID",
  "GDriver_demand__ILlE": "已下架",
  "FoodB_optimization_Not_started_XTpL": "未开始",
  "Internal_Tools_App2_bbEY_frCr": "是否确认删除？",
  "FoodC_replace_Clear_Filter_iwTY": "清空筛选器",
  "FoodB_030_SQUQ_YDRS": "非我的门店",
  "Gattaran_add_bXDc_IEuz": "Connectivity(Daily average)>60%",
  "Gattaran_online_HStX_yFLt": "首次在线时间",
  "FoodB_0622_Increase_store_kZfr": "增加门店对比",
  "Gattaran_side__nJvf": "星期三",
  "FoodOpB_CRM_Party_B_BCQp": "乙方企业注册号",
  "Internal_Tools_App_xWMr_AnaW": "打电话",
  "FoodD_Name_May_zYiz": "五月",
  "FoodB_list_KP_Name_GQRs": "KP姓名",
  "Gattaran_statusbar2_zVad_yPpm": "审批失败",
  "Gattaran_20240409_cmyA_kTJa": "报名中{{num}}",
  "Gattaran_jumpnewstore_kzko_qHFR": "点击查看流量数据",
  "Gattaran_20240409_krBB_ZQnQ": "未开始{{num}}",
  "FoodB_Show_Taxpayer_Document_eadz": "纳税人证件类型（当地）",
  "Gattaran_opt_Qotr_nHZK": "经营数据",
  "Gattaran_v1_pVFJ_UAfK": "为商户报名招商活动",
  "FoodOpB_center_Rejection_FiOu": "驳回",
  "Gattaran_management_SqSM_FwHJ": "已拜访",
  "Gattaran_statusbar2_QQFK_mEcw": "审批",
  "Internal_Tools_App_kPwc_tSpo": "信息尚未保存，确认要离开吗？",
  "FoodB_Analysis_Nearly_7_wumh": "近{{day}}天",
  "FoodB_2_During_the_QHhU": "活动时间",
  "Gattaran_202406_ODsG_JrEY": "任务待完成",
  "Gattaran_Visit_Formula_item_xqos": "公式=（事项1得分/4+事项2得分/4+...）/事项个数*100%",
  "Gattaran_ES_ZfMz_IKyd": "在线率",
  "Gattaran_transformation__AByw": "签约主体类型",
  "FoodB_orders_Select_Store_gtmG": "选择门店",
  "Internal_Tools_App_iieD_DElO": "税号：{{Tax_id}}",
  "FoodB_audit_Suspected_duplicate_ntLx": "疑似重复门店",
  "Internal_Tools_App_Qhjz_HpXk": "经度：{{lat}}",
  "Gattaran_202406_CltK_IQGG": "创建的（{{N}}）",
  "Gattaran_AlertV1_yVMN_aZdo": "重点关注的商家",
  "FoodB_Show_Taxpayer_Document_TFeg": "纳税人证件类型（全国）",
  "Gattaran_0_App_Operator_ikIT": "App操作员",
  "Gattaran_202406_ztqf_jOPK": "未完成",
  "Gattaran_202406_dDeL_ULkW": "去查看",
  "Gattaran_function__vJQK": "当前已是最新版本",
  "Gattaran_Optimization_SGMS_fnOQ": "前往DiDi Food",
  "FoodB_optimization_Buy_gifts_daUI": "买赠",
  "Gattaran_opt_EFMf_fxMF": "上次拜访",
  "FoodOpB_CRM_Taxpayer_Information_Flde": "纳税人信息附件照片（当地）",
  "Gattaran_opt_QCLu_UWmJ": "已取消的订单",
  "Gattaran_0_Can_t_zMtY": "联系不上",
  "FoodB_2_R_Burn_CgKc": "R burn",
  "FoodB_system_Competition_NFPY": "竞对",
  "Gattaran_statusbar2_UQFc_DODT": "跟进中",
  "Gattaran_0_Publicity_cards_HSYt": "宣传牌",
  "Gattaran_management_fVhj_uFOo": "欢迎随时与我们沟通，谢谢！",
  "FoodB_management_Untied_tYEF": "解绑",
  "Gattaran_form_mvdB_WqwR": "添加接下来的行动",
  "Gattaran_mgt_System_recommended_AeDM": "系统推荐排序",
  "Gattaran_optimation_QjMB_BOgo": "陪访表单页面意外退出，点击“重新打开”以再次进入上一次停留的页面。",
  "Gattaran_form_jbbp_rBPM": "离开",
  "Gattaran_transformation__hYxT": "关联签约主体",
  "Gattaran_Edition_oXdU_Hnsz": "我们没有找到你搜索的内容",
  "Internal_Tools_App_fEpS_WJta": "经度",
  "FoodB_V1_zPrX_zWoE": "R burn/GMV变化量",
  "FoodB_management_Sector_LRtz": "所属部门",
  "FoodB_0905__pNYF": "各订单类型有重叠，加和不等于当日完单量",
  "Gattaran_0_Price_management_rLvu": "价格管理",
  "FoodB_0623_Store_GZFE": "门店",
  "Gattaran_opt_BEjW_mzFb": "首次在线后可查看数据报告",
  "FoodOpB_results_No_store_ZJQG": "无店铺有效联系方式",
  "Gattaran_0_If_you_xGEs": "有未填写项，请完善信息",
  "FoodB_2__CkLu": "同城市",
  "FoodB_resivion_Inaccurate_information_dmRA": "信息不准确？",
  "FoodB_0905__Uuug": "诊断规则",
  "Gattaran_Visit_VrZq_Dgvh": "额外的机会",
  "Internal_Tools_App_iCHw_cRVH": "其它",
  "Gattaran_0_Visit_Registration_AZYL": "店铺采集信息",
  "Gattaran_0_Increase_social_MxxK": "为商家增加社交媒体",
  "Internal_Tools_CRM_jrXd_olfC": "最佳拜访时间",
  "Internal_Tools_App_mzyX_fryx": "选择时间",
  "Gattaran_Optimization_IGsH_WCQM": "支持跳转到DiDi Food",
  "Gattaran_v2_LSlZ_XduF": "点击了解规则，助力商家成为{{DiDi_Top}}",
  "FoodB_0623_Indicators_auar": "指标",
  "Gattaran_center__HcEx": "已将全部消息标记为已读",
  "Gattaran_0__mpop": "请到App中打开或在D-Chat中搜索“Gattaran feedback”进群反馈",
  "FoodOpB_Translation_Legal_persons_RduO": "法人",
  "Gattaran_management_WVOf_JOti": "查看",
  "Gattaran_optimation_MQrO_OvRt": "是否希望恢复页面？",
  "Gattaran_resivion_More_KTYU": "更多",
  "Internal_Tools_App_iRIy_dqLi": "本月",
  "FoodOpB_efficiency_Store_UpAc": "已签约商户数",
  "Gattaran_V1_ZDXa_aTjw": "有效营销活动列表",
  "FoodB_0905__uatF": "高于同商圈{{number_or_rate}}商家",
  "Gattaran_202406_IIUg_NlxT": "商家信息",
  "Internal_Tools_App_BEnH_Yxgl": "最短查询范围是2天",
  "Gattaran_202406_htDL_CJTB": "任务创建人",
  "FoodB_0905__kaPI": "诊断分数",
  "Gattaran_0__tWkQ": "特价菜",
  "Gattaran_Optimization_cVHJ_PCUb": "点击展示商家营业时间明细",
  "FoodB_tagging_You_chose_tIKm": "您选择了无效商机原因为：店铺不存在，当前位置距离店铺大于{{distance}}，请检查！",
  "Gattaran_add_xwYd_UfEG": "logo",
  "Gattaran_0_Contrast_the_YwEa": "与竟对平台对比降价",
  "Gattaran_V1_gCzF_PJKj": "{{num}}个营销活动待跟进",
  "Gattaran_opt_xawD_vBtI": "日均在线时长",
  "Internal_Tools_App_oOyW_tZKN": "已下架",
  "FoodOpB_1_Visit_dXVU": "拜访",
  "Internal_Tools_CRM_ZxcL_MqnG": "采购价",
  "FoodB_leads_The_relationship_jkYA": "倾向联系时间",
  "Gattaran_form_KjAJ_bymE": "拜访计划详情",
  "Gattaran_BDapp_Pder_myCx": "BD门户（CKA）",
  "FoodOpB_StoreInput_Store_Information_mIjy": "门店KP信息",
  "FoodB_V2_Satisfied_with_YFEM": "对现状感到满意",
  "Gattaran_0915__UZgP": "统计周期{{date1_date2}}",
  "FoodB_tagging_You_chose_lWSH": "您选择了无效商机原因为：非零售店铺，当前位置距离店铺大于{{distance}}，请检查！",
  "Gattaran_202406_JIgY_duWs": "收到的",
  "Internal_Tools_0523_ZlFL_LzUJ": "去注册",
  "Gattaran_0_Not_willing_JFcK": "不愿意",
  "Internal_Tools_App_kYus_Rwmo": "电话号码",
  "Gattaran_0__sDLK": "点击加载按钮查看更多门店",
  "Internal_Tools_App_giWs_FLQG": "输入备注作为补充信息",
  "Gattaran_202311_WXzo_Yqns": "添加有效商机",
  "FoodOpB_Translation_Tax_ID_yEbh": "税号",
  "Gattaran_form_HuGK_YufB": "编辑拜访计划",
  "FoodB_Launch_Illegal_import_jlOS": "输入非法",
  "Gattaran_Collection__kwys": "地图页面支持发起导航啦",
  "FoodD_Name_November_BcWL": "十一月",
  "Gattaran_0_No_contacts_EeBR": "没有联系人",
  "Internal_Tools_CRM_LzIy_MlTO": "品牌",
  "FoodB_Wordings_MYHl_FXti": "选择原因",
  "Gattaran_opt_FWKd_AEaY": "点击输入线下经营信息",
  "FoodD_Incentive_In_progress_GNvs": "进行中",
  "FoodB_2_Visit_Records_LiJy": "拜访记录",
  "Internal_Tools_App_pcBI_HhnE": "重置",
  "FoodB_202204_Order_eJXF": "订单",
  "Gattaran_Visit_Fill_in_aFuS": "填写陪访",
  "FoodB_store_Order_Coupon_zpSY": "下单返券",
  "Gattaran_20240409_JmCU_vNnz": "天后开始报名",
  "FoodB_2_Call_visit_NGFu": "电话",
  "FoodB_I_Cancelled_orders_XeVk": "取消订单数",
  "FoodB_1__GxZN": "近30天的数据",
  "Gattaran_Feedback__amKQ": "高",
  "Gattaran_0_Is_it_uBZs": "是否是黑暗厨房",
  "Gattaran_0_Price_of_cdsJ": "滴滴相对于其他应用的价格",
  "Gattaran_optimization__HjAa": "再次返回退出Explorer",
  "Internal_Tools_App2_zKCw_IMpc": "周六",
  "Internal_Tools_CRM_CqzP_fbCc": "城市",
  "Gattaran_form_MglG_FNNK": "拜访时间",
  "FoodOpB_Translation_ID_Card_jQZG": "身份证",
  "Gattaran_management_JcWN_FRMj": "与商家达成的协议",
  "FoodC_cash_WQNI_uYzC": "添加",
  "FoodB_collection_625_System_iWnH": "625-通过技术平台获得收入的商业活动制度",
  "FoodOpB_Org_Edit_Gphm": "编辑",
  "Gattaran_Optimization_ZhGy_ZlOk": "增加营业时间详情",
  "FoodB_0919__CONM": "下架菜品数",
  "Gattaran_202406_EMkK_osti": "商家维度",
  "Internal_Tools_App_fJQz_FBzw": "近{{month}}月",
  "Internal_Tools_App_XqAW_HtbS": "实时价格",
  "FoodOpB_1_Plan_Nfsn": "计划中",
  "Internal_Tools_CRM_nvDw_fHdG": "邮编",
  "FoodOpB_Management_You_can_aDLi": "您可通过点击“申诉”创建您的新店铺，预计需要等待2天时间可查看审核结果。",
  "FoodOpB_Org_Can_not_swrB": "删除后不可恢复，是否确认删除？",
  "FoodB_0622_The_statistical_NUCJ": "数据统计口径为T+1，按照近30天菜品销量排序",
  "Gattaran_opt_OIIn_XXkw": "查看审核结果",
  "Gattaran_form_KvgC_Afkb": "退出确认",
  "Gattaran_V1_ZkCf_UOay": "清空",
  "Gattaran_Edition_mvmO_sigb": "当前选择的日期与已存在的拜访计划重复，提交后会覆盖之前的拜访计划。",
  "FoodB_0921__iLXg": "数量",
  "Gattaran_20240401_iQeT_rFly": "感谢你的反馈",
  "Internal_Tools_App_Bufi_ZBrZ": "导航",
  "FoodB_0919__etPs": "多种类营销",
  "FoodOpB_management_Actual_value_dSKC": "实际值",
  "FoodB_202207_Default_BQmA": "默认",
  "FoodOpB_app_Collecting_documents_wTBe": "搜集文档中",
  "FoodB_V2_DQvR_Redp": "请在BDapp中使用分享功能。",
  "Gattaran_202406_Rqhc_vORg": "商家任务",
  "Gattaran_optimation_uLZP_VtyM": "重新打开",
  "Gattaran_mgt_All_SSzR": "全部",
  "Gattaran_202406_ObEK_ztcK": "该指标数据暂未完成计算，请明天查看",
  "Gattaran_form_pQiE_NLFe": "根据店铺诊断结果推荐的拜访目的",
  "FoodB_IV_Tips_DFOG": "提示",
  "Gattaran_202406_kjmQ_Epeu": "创建的",
  "Gattaran_0_What_are_AWJz": "该区域发现的主要机会是什么",
  "Internal_Tools_Optimization_KJgL_fWkX": "今日营业时间",
  "Gattaran_jumpnewstore_FJjw_JHRB": "新店成长-任务已完成",
  "Gattaran_Visit_Advantages_CSEp": "优势",
  "FoodC_improve__ovBF": "份量少",
  "Gattaran_0__ytbk": "高优",
  "FoodB_audit_New_and_yYux": "新旧店铺名称差异",
  "Gattaran_Visit_Related_Visit_RGas": "关联拜访记录",
  "Gattaran_side__OvkZ": "星期四",
  "FoodOpB_tagging_Store_does_sduq": "店铺不存在",
  "FoodOpB_Gattaran_Reset_ILVf": "重置",
  "Gattaran_transformation__QWlQ": "请补充完整必填信息",
  "Gattaran_0__jRoM": "打开D-Chat",
  "FoodB_time_Business_hours_kRTs": "假期营业时间",
  "Internal_Tools_App_phGO_IYRt": "排序",
  "FoodB_0921__kEaD": "Burn%",
  "FoodB_Analysis_New_customers_vYDl": "新客",
  "Fintech_Credit_2__TvDQ": "撤销原因",
  "Gattaran_202406_UOFx_ekzp": "取消",
  "FoodB_resivion_Overdue_visit_jTHW": "过期拜访",
  "FoodOpB_CRM_Taxpayer_Address_EBwy": "纳税人地址（全国）",
  "FoodOpB_analysis_Performance_analysis_NMbA": "绩效数据分析",
  "FoodOpB_set_Determination_wYFG": "确定",
  "FoodB_2__FNaI": "同商圈",
  "请输入XXXXX-XXX": "",
  "合同类型": "",
  "回收完成": "回收完成",
  "签约状态": "",
  "正常经营": "正常经营",
  "合作拜访结果": "",
  "执照照片": "",
  "重复门店电话": "",
  "暂无合作意愿": "",
  "日常维护信息": "",
  "签字": "",
  "请选择不合作原因": "",
  "首次完单时间": "",
  "支行号": "",
  "暂无": "",
  "获取商圈中...": "",
  "周四": "",
  "请在Gattaran上完成撤销申请！": "",
  "输入有误": "",
  "设备信息": "",
  "申诉通道": "",
  "目前营业中门店": "",
  "店主（法人）": "店主（法人）",
  "未达到任务完成的标准": "",
  "授权书照片": "",
  "证号": "",
  "法人CPF": "",
  "工具": "",
  "工商登记时间": "",
  "未确定合作": "未确定合作",
  "Curp号必须为18位字符": "",
  "提交成功": "",
  "公司": "",
  "驳回原因": "",
  "城市": "",
  "发放时间": "",
  "商机转交": "",
  "保存并发邮件&短信": "",
  "签约授权书": "",
  "信息已完善": "",
  "上拉加载更多": "",
  "支付验证未通过": "",
  "等待原因": "",
  "平台配送及自配送不允许同时选择不支持": "",
  "平台管控中": "平台管控中",
  "信心度A": "信心度A",
  "信心度B": "信心度B",
  "信心度C": "信心度C",
  "是": "",
  "同意上线": "同意上线",
  "查看更多": "",
  "KP CPF": "",
  "评分": "",
  "法人名片假名": "",
  "我的拜访": "我的拜访",
  "居民证明": "",
  "确认签章": "",
  "合作拜访": "",
  "拜访记录": "",
  "无合作意向": "",
  "PAD型号": "PAD型号",
  "乙方名称片假名": "",
  "开户行": "",
  "点击收起": "",
  "暂停营业中": "暂停营业中",
  "周日": "",
  "已关闭": "",
  "CNPJ": "",
  "KP姓片假名": "",
  "有效": "",
  "CKA BD": "",
  "确定删除吗？": "",
  "日常工具": "",
  "正常": "",
  "掉线中": "掉线中",
  "沟通经营问题（服务管控+店铺装修）": "沟通经营问题（服务管控+店铺装修）",
  "梅斯卡尔酒": "",
  "帐户持有人CPF": "",
  "商户运营": "",
  "菜单照片": "",
  "去设置": "",
  "跟进中": "",
  "销量(单/周)：": "",
  "支持以下哪种支付方式": "",
  "失败号": "",
  "谷歌地图": "",
  "打开浏览器失败": "",
  "银行卡号仅支持数字输入": "",
  "佣金补贴周期": "",
  "沟通新店保护设置": "沟通新店保护设置",
  "公共契约编号": "",
  "首次完成开店检查时间": "",
  "已签约": "",
  "商家概况": "",
  "执行团队": "",
  "未连接到服务器": "",
  "KP CPF照片": "",
  "自配送起送费": "",
  "电话号码不对": "电话号码不对",
  "我知道了": "",
  "考虑中": "考虑中",
  "Curp号": "",
  "已归档": "",
  "是否需要pad": "",
  "点击校准": "",
  "附件照片": "",
  "%s级": "",
  "人工标记平台：": "",
  "审核通过商户数": "",
  "老版无Curp": "",
  "首页": "首 页",
  "商机无效": "",
  "未完成": "未完成",
  "支付验证": "",
  "返回": "",
  "账号无法登陆": "",
  "纳税照片": "",
  "建议拍摄店面照片": "",
  "标题": "",
  "不承诺": "",
  "不能超过%d字": "",
  "佣金补贴比例": "",
  "放弃": "",
  "请选择营业天数": "",
  "KP名": "",
  "单次最大扣费金额": "",
  "持卡人姓": "",
  "请输入门店ID": "",
  "售卖时间": "",
  "是否有异常标签": "",
  "是否有违规记录": "",
  "审批通过": "",
  "上传最大数量为%d张，图片上限为5MB": "",
  "银行代理number": "",
  "地区": "",
  "门店logo": "",
  "商家不愿培训": "商家不愿培训",
  "审核中商户数": "",
  "银行": "",
  "已完成设置": "已完成设置",
  "已添加": "",
  "复制成功": "",
  "愿意改善": "愿意改善",
  "首次有效上线时间": "",
  "My Number卡": "",
  "设备回收": "设备回收",
  "补充照片": "",
  "再次尝试电话联系": "再次尝试联系",
  "填写拜访": "填写拜访",
  "门店POI不能为空": "",
  "商机信息": "",
  "Pad": "",
  "经营状态": "经营状态",
  "与KP完成沟通即视为有效拜访": "",
  "快速拍摄": "",
  "设备故障": "",
  "菜单信息": "",
  "出生日期": "",
  "自配送费": "",
  "（创建超级管理员账号）": "",
  "请输入": "",
  "法人姓": "",
  "朗姆酒": "",
  "合同记录": "",
  "待办任务": "待办任务",
  "（商家接收邮件）": "",
  "已首次上线商户数": "已首次上线商户数",
  "不想使用外卖模式": "不想使用外卖模式",
  "一般酒精产品贩卖准证": "",
  "请选择": "",
  "营业时间段不能重叠": "营业时间段不能重叠",
  "有特殊情况不能上线": "有特殊情况不能上线",
  "门店PAD信息": "门店PAD信息",
  "商户调研": "商户调研",
  "葡萄酒": "",
  "推迟": "",
  "再次申请": "",
  "自配送佣金比例": "",
  "门店地址": "",
  "推荐完成": "推荐完成",
  "拜访内容": "拜访类型",
  "活期": "",
  "创建时间": "",
  "过期拜访": "过期拜访",
  "刷新成功": "",
  "解约": "",
  "价格承诺": "",
  "电子合同": "",
  "KP电话": "",
  "不愿配合": "不愿配合",
  "银行流水单": "",
  "是否需要拍照": "是否需要拍照",
  "请输入13位有效数字": "",
  "LTE": "LTE",
  "PAD领取人": "PAD领取人",
  "银行名称": "",
  "确定": "",
  "金额": "",
  "待领取": "",
  "停止营业": "",
  "合作谈判": "合作谈判",
  "KP姓名:": "",
  "商机详情": "",
  "信息未完善": "",
  "CPF": "",
  "查看": "",
  "证件照片": "",
  "税号": "",
  "促进商户首次上线": "促进商户首次上线",
  "语言": "",
  "登录商户账号": "",
  "未联系到关键目标": "未联系到关键目标",
  "任务类型": "",
  "打款授权书": "",
  "营业时间": "",
  "电话培训": "电话培训",
  "联系不上": "联系不上",
  "编辑商机": "",
  "拜访时间": "拜访日期",
  "纸质合同": "",
  "保存草稿": "",
  "账号": "",
  "接收人": "",
  "円": "",
  "无多余人力(过于繁忙)": "无多余人力(过于繁忙)",
  "预计参加：店铺配置": "预计参加：店铺配置",
  "WIFI": "WIFI",
  "无效": "",
  "应上线商户数": "",
  "结算信息": "",
  "(R$)": "",
  "关于": "",
  "设置": "",
  "担心配送质量": "",
  "数值只能是%s位小数": "",
  "CKA": "",
  "录入合同基础信息": "",
  "未见KP": "",
  "不参加": "不参加",
  "不保存": "",
  "酒精销售许可证": "",
  "手机号": "",
  "疑似KA": "",
  "是否有效拜访": "",
  "完成培训": "完成培训",
  "请输入有效的门店id": "",
  "持卡人姓名": "",
  "系统标记平台：": "",
  "其他": "",
  "人工标记平台": "",
  "品牌名称": "",
  "选择日期": "",
  "必须为%d或%d字": "",
  "重复门店ID": "",
  "工商登记注册地": "",
  "白兰地": "",
  "数据": "数据",
  "复制": "",
  "商户签约": "",
  "乙方邮箱": "",
  "无营业资质": "",
  "活跃程度": "活跃程度",
  "找不到店": "",
  "提交开店申请商户数": "",
  "不合作原因": "",
  "关联品牌名称": "",
  "门店距离": "",
  "门店名称": "",
  "陪访人": "陪访人",
  "银行账户digit": "",
  "营业时间不能重复设置": "营业时间不能重复设置",
  "纳税信息": "",
  "完善以下": "",
  "乙方联系人手机": "",
  "30天后解约": "30天后解约",
  "上传照片不能超过%dMB，请重新上传": "",
  "电话支持字符：数字、英文逗号，录入其他符号，不允许提交": "",
  "您当前的网络环境不太好": "",
  "审核失败": "",
  "模式选择": "",
  "商圈": "",
  "类型": "",
  "启动费太高": "启动费太高",
  "加价限制": "",
  "获得初步意向": "获得初步意向",
  "任务ID": "",
  "不确定合作意向": "不确定合作意向",
  "添加营业时间": "",
  "CNPJ号必须为14位数字": "",
  "请输入半角片假，不能超过48个字符": "",
  "回收pad": "回收pad",
  "商家信息": "",
  "自配送范围及时长": "",
  "市政经营许可证": "",
  "至": "",
  "图片": "",
  "未完善": "未完善",
  "打烊中": "打烊中",
  "菜单": "",
  "下一步": "",
  "正式拜访": "正式拜访",
  "具备上线能力": "",
  "金额(MX$)": "",
  "平台配送最低服务费": "",
  "系统标记平台": "",
  "请选择无效拜访原因": "",
  "过于繁忙": "过于繁忙",
  "日本": "",
  "若证件类型选择“老版无Curp”，需上传补充附件": "",
  "拜访方式": "拜访方式",
  "选择城市": "",
  "退出登录": "",
  "日常提醒商家上线": "日常提醒商家上线",
  "回收未完成": "回收未完成",
  "上传最大数量为1张，图片上限为5M": "",
  "千": "",
  "签约%d周后": "",
  "乙方联系人CPF": "",
  "照片": "照片",
  "法人姓名": "",
  "营业信息": "营业信息",
  "添加电话": "",
  "打开地图失败": "",
  "商家位置": "",
  "开始扣费时间": "",
  "我负责的": "",
  "平台配送": "",
  "KP邮箱": "",
  "封禁": "",
  "合同信息": "",
  "卫生安全通知": "",
  "账号名称": "",
  "现金支付": "",
  "座机": "",
  "乙方联系人CPF照片": "",
  "许可证有效期": "",
  "还在考虑，需要追客": "还在考虑，需要追客",
  "支行名称": "",
  "门店ID": "",
  "提交材料": "",
  "失败原因": "",
  "无法联系到KP": "",
  "授权人": "",
  "手机": "",
  "请输入XXX-XXXX": "",
  "我的新增": "",
  "KP名片假名": "",
  "没联系到": "没联系到",
  "不需要": "",
  "已拜访商机数": "",
  "仅支持数字输入": "",
  "铺设失败": "",
  "任务完成": "",
  "复制链接": "",
  "已完成": "",
  "草稿中": "",
  "否": "",
  "商户主体类型": "",
  "经营品类": "",
  "待定": "",
  "完单量": "",
  "担心外卖模式(不想使用外卖模式)": "担心外卖模式(不想使用外卖模式)",
  "乙方注册地址邮编": "",
  "营业执照": "",
  "账户余额：": "",
  "结算信息照片": "",
  "价格信息": "",
  "证件类型": "",
  "威士忌": "",
  "在线": "",
  "销售姓名": "",
  "合同照片": "",
  "龙舌兰酒": "",
  "编辑商机成功": "",
  "拜访对象": "拜访对象",
  "营业中": "营业中",
  "请输入数字": "",
  "全部": "",
  "取消订单量": "",
  "电话": "",
  "请输入门店名称搜索": "",
  "当前门店总数": "",
  "已签约商户数": "",
  "日常维护": "",
  "合同版本": "",
  "商机价值": "",
  "联系方式": "联系方式",
  "管控状态：": "",
  "审批中": "",
  "拜访目标": "",
  "门店类型": "",
  "创建成功": "",
  "账户类型": "",
  "KA BD": "",
  "门店名称片假名": "",
  "乙方注册地址片假名": "",
  "对私": "",
  "个人企业": "",
  "订单均价": "",
  "需要完善": "需要完善",
  "撤销申请": "",
  "请先输入门店地址": "",
  "默认": "",
  "请补全营业时间": "",
  "校准POI": "",
  "全部门店": "",
  "不支持": "",
  "暂停经营": "暂停经营",
  "添加营业时间段": "",
  "合同基础信息": "",
  "请输入5位有效数字": "",
  "提交审批后，在审批过程中信息不可修改，是否确认提交？": "",
  "证件号": "",
  "有限责任公司": "",
  "长期有效": "",
  "乙方注册地址": "",
  "饮料店期间限定酒品贩卖准证": "",
  "请录入关闭原因": "请录入关闭原因",
  "土地使用许可证": "",
  "重复门店": "",
  "普通商家": "",
  "距离": "距离",
  "不小于%d": "",
  "不愿完成": "不愿完成",
  "推迟发放": "推迟发放",
  "必须为%d字": "",
  "担心外卖模式": "",
  "当该餐厅存在多个经营者时，此处必须填写合同签署人或授权合同签署人姓名": "",
  "提交成功！": "",
  "未完成PAD发放": "未完成PAD发放",
  "有效商机数": "",
  "无相关信息": "",
  "查看拜访记录": "查看拜访记录",
  "抽佣：": "",
  "删除": "",
  "银行卡号": "",
  "其他信息": "",
  "起始时间": "",
  "预计进行改善": "预计进行改善",
  "不愿改善": "不愿改善",
  "签约数据": "签约数据",
  "登记簿照片": "",
  "电销团队": "",
  "完成时间": "",
  "放弃原因": "",
  "KP电话:": "",
  "完成PAD发放": "完成PAD发放",
  "完成工作": "",
  "提交中": "",
  "营业时间段": "",
  "任务完成标准": "",
  "商户官网": "",
  "门脸照片": "",
  "门店电话:": "",
  "新建商机成功": "",
  "添加拜访计划": "添加拜访计划",
  "营业执照照片": "",
  "驾照": "",
  "个人信息": "",
  "订单量": "",
  "董事": "",
  "有效期": "",
  "周三": "",
  "高端饭店": "",
  "是否已经加入其他外卖平台？": "",
  "周一": "",
  "点击查看原因": "",
  "去修改": "",
  "KP电话是店长账户": "",
  "确认要清空搜索记录吗？": "",
  "状态机": "",
  "暂无数据": "",
  "拜访详情": "",
  "启动费": "",
  "疑似CKA": "",
  "选择职位": "选择职位",
  "提交人": "提交人",
  "签约信息": "",
  "审核中": "",
  "请输入半角片假名": "",
  "请选择无意愿原因": "",
  "（多选）": "（多选）",
  "上一步": "",
  "周五": "",
  "执行人": "",
  "填写拜访备注可供后续跟进参考": "",
  "扣费次数大于等于1": "",
  "线下": "线下",
  "效率": "效率",
  "无效商机": "无效商机",
  "拜访历史": "",
  "封禁中": "封禁中",
  "原因": "",
  "CPF号必须为11位数字": "",
  "周二": "",
  "保存": "",
  "商户号": "",
  "参加": "参加",
  "万": "",
  "乙方联系方式": "",
  "加价限制（%）": "",
  "上传交付照片": "",
  "商户主体类型为公司时需提供此项内容": "",
  "编辑经营信息": "",
  "开户公司CNPJ": "",
  "门店信息": "",
  "当前数据计算至:": "",
  "店长": "店长",
  "已完成培训": "已完成培训",
  "不限": "",
  "品牌授权书": "",
  "P1": "",
  "请输入3位有效数字": "",
  "P0": "",
  "P2": "",
  "转让": "",
  "自入驻": "",
  "老版有Curp": "",
  "店内环境": "",
  "详细原因": "",
  "金酒": "",
  "请输入7位有效数字": "",
  "签字授权书": "",
  "无效原因": "",
  "持卡人地址": "",
  "拜访备注": "",
  "标记问题门店": "",
  "已完善": "已完善",
  "指定": "",
  "发起者": "",
  "抽佣问题": "",
  "合法代表": "",
  "自定义": "",
  "店铺主体类型是法人时必填（13位数，国税厅公布的法人号码）": "",
  "单次最大扣费金额(MX$)": "",
  "重复门店名称": "",
  "KP姓名": "",
  "IMEI": "IMEI",
  "负责人表示不合作": "负责人表示不合作",
  "去升级": "",
  "将本页截图发送至didi@didichuxing.com;总部进行人工线下校验，并在7日内反馈申诉结果;": "",
  "银行代理digit": "",
  "巴西": "",
  "捡入": "",
  "线上支付": "",
  "竞品独家签约": "",
  "总评价人数": "",
  "周六": "",
  "门店电话": "",
  "标红信息即可完成添加": "",
  "疑似CKA/KA": "",
  "执行者": "",
  "法人CPF照片": "",
  "待办事项": "",
  "预计休业": "预计休业",
  "其他筛选": "其他筛选",
  "是否自配送：": "",
  "当前定位失败": "",
  "优先级": "",
  "任务来源": "",
  "可提现金额：": "",
  "自配送订单量（单/周）": "",
  "审核完成": "",
  "店员": "店员",
  "冻结金额：": "",
  "签约状态：": "",
  "时间格式错误": "",
  "审批失败": "",
  "确定合作": "确定合作",
  "啤酒": "",
  "接收电子合同的邮箱": "",
  "门店照片": "",
  "电话预约": "预约拜访",
  "选择商圈": "",
  "KA": "",
  "结束时间": "",
  "确认银行卡号": "",
  "在留卡": "",
  "访谈&调研": "访谈&调研",
  "承诺": "",
  "实际上线商户数": "",
  "暂不支持复制功能": "",
  "不能为空": "",
  "暂停营业": "",
  "提案失败": "提案失败",
  "经营信息": "",
  "依据门店POI反解": "",
  "拜访结果": "",
  "乙方联系人姓": "",
  "银行卡号必须为18位": "",
  "储蓄": "",
  "首位必须是1，必须输入11位": "",
  "无银行账号": "",
  "KP所属部门": "",
  "成功留存": "成功留存",
  "伏特加": "",
  "暂时不愿上线": "暂时不愿上线",
  "沟通经营问题": "沟通经营问题",
  "支持": "",
  "请输入正确的邮箱地址": "",
  "确认要退出吗？": "",
  "乙方联系人": "",
  "公证编号和地区": "",
  "后续陌拜": "后续陌拜",
  "持卡人名": "",
  "通过时间": "",
  "请输入银行名称或五十音": "",
  "指已签约并且上线接单的门店": "",
  "线下店铺菜单": "",
  "无多余人力": "",
  "格式错误": "",
  "合同生效日期": "",
  "分发失败": "",
  "使用此功能需升级至最新版本": "",
  "任务分发": "",
  "乙方联系人名片假名": "",
  "ESC": "",
  "无法获取手机定位，请检查": "",
  "上传最大数量为3张，图片上限为5M": "",
  "佣金审核证明": "",
  "范围": "",
  "公司公证": "",
  "审核通过": "",
  "查看申请": "",
  "未签约": "",
  "申请签约": "",
  "已校准": "",
  "审核结束": "",
  "具备上线能力商户数": "",
  "邮编": "",
  "手机和座机都只支持10位数字": "",
  "不允许特殊字符": "",
  "KP姓": "",
  "店内桌数（桌）": "",
  "待提交": "",
  "附件说明": "",
  "查看示例": "",
  "工商登记号码": "",
  "去填写": "",
  "待办理": "",
  "账户状态：": "",
  "设备铺设结果": "",
  "上传失败，请重新上传": "",
  "支持上传附件，含关键信息页需单独拍照上传至【执照照片】": "",
  "签约中": "",
  "不需要pad": "",
  "高端饭店不做外卖": "",
  "最多%d个": "",
  "合同编号": "",
  "门店POI": "",
  "开店信息": "",
  "商家开店检查": "",
  "KP电话（仅支持手机）": "",
  "关联签约主体名称": "",
  "法人姓片假名": "",
  "成功": "",
  "开始时间": "",
  "审批邮件": "",
  "门店品类": "",
  "运营数据": "运营数据",
  "新建商机": "",
  "任务基础信息": "",
  "食堂订单量（单/周）": "",
  "新版": "",
  "需要": "",
  "佣金策略合同模板": "",
  "任务详情": "",
  "预计参加：DiDi配置": "预计参加：DiDi配置",
  "请选择等待原因": "",
  "信息尚未保存，是否保存？": "",
  "请选择接收人": "",
  "股份有限公司": "",
  "乙方联系人头衔": "",
  "处理时间": "处理时间",
  "打款": "",
  "资质类型": "",
  "门店价值": "",
  "编辑": "",
  "当前位置距商家": "",
  "商家是否在线：": "",
  "护照": "",
  "发起验证申请": "",
  "银行账户number": "",
  "请填写真实原因": "",
  "不能超过%d": "",
  "公证日期": "",
  "已签章": "",
  "商户留存措施": "商户留存措施",
  "自配送": "",
  "失败原因详情": "",
  "金额(円)": "",
  "土地使用许可证执照照片": "",
  "签约": "",
  "任务": "",
  "首次完成签约时间": "",
  "当前门店总数=未签约门店+签约中门店+已签约门店": "",
  "上传最大数量为%d张，图片上限为%dM": "",
  "法人名": "",
  "个人": "",
  "确定合作，准备收集资料": "确定合作，准备收集资料",
  "上传最大数量为1张，图片上限为5MB": "",
  "乙方联系方式是超级管理员账户": "",
  "乙方联系人名": "",
  "乙方联系人姓片假名": "",
  "有效在线商户数": "",
  "歇业中": "歇业中",
  "基础信息": "",
  "销售电话": "",
  "重复门店与创建门店的距离": "",
  "门店": "",
  "全部区域": "",
  "拆迁": "",
  "请选择失败原因": "",
  "搜索记录": "",
  "门店地址片假名": "",
  "未添加": "",
  "加载中": "",
  "请输入12位有效数字": "",
  "不愿上线": "不愿上线",
  "CKA/KA BD": "CKA/KA BD",
  "完成电话": "完成电话",
  "乙方名称": "",
  "更新时间": "更新时间",
  "标准合同模板": "",
  "签约状态（多选）": "",
  "12位数，法人登记簿上的号码": "",
  "请在Gattaran查看": "",
  "被授权人证件照片": "",
  "希望解约/回收pad": "希望解约/回收pad",
  "乙方联系方式（仅支持手机）": "",
  "附件类型": "",
  "计划完成设置": "计划完成设置",
  "有合作意向": "",
  "非餐饮": "",
  "附件文件": "",
  "法人信息": "",
  "点击上传": "",
  "扣费次数": "",
  "培训使用方法": "",
  "陌拜": "陌拜",
  "已完成改善": "已完成改善",
  "扣费比例": "",
  "预定上线": "预定上线",
  "没有更多数据了": "",
  "未知": "",
  "提交": "",
  "填写拜访信息": "",
  "新功能培训": "新功能培训",
  "详细录入规则": "",
  "不再发放": "不再发放",
  "门店详情": "",
  "提交时间": "",
  "登记簿": "",
  "备注": "备注",
  "不在线": "",
  "提交后将无法正常签约": "",
  "铺设成功": "",
  "催促商家首次上线": "催促商家首次上线",
  "对公": "",
  "商户运营价值": "",
  "米": "",
  "创建失败": "",
  "已核准": "",
  "确认签章时需上传合同附件，请在Gattaran完成确认！": "",
  "提交至审批": "",
  "在线状态：": "在线状态：",
  "资质信息": "",
  "物料发放": "物料发放",
  "姓名": "姓名",
  "Opening Call": "Opening Call",
  "两次银行卡号不一致！": "",
  "取消": "",
  "法人证件": "",
  "门店营业时间": "",
  "无法获取应用版本信息": "",
  "商家位置为": "",
  "Curp号必须为大写字母": "",
  "活动招商": "活动招商",
  "墨西哥": "",
  "资料录入": "资料录入",
  "地区与语言": "",
  "平台配送佣金比例": "",
  "待完成": "",
  "开户公司名": "",
  "选项和输入框不能为空": "选项和输入框不能为空",
  "邮件&短信已发送给商家": "",
  "您提交的无效原因有误，请检查": "",
  "本模块支持上传文件，可至PC端操作": "",
  "确定要验证当前店铺的银行卡号？点击【确定】发起【支付验证】申请": "",
  "发送邮件&短信": "",
  "正常门店": "",
  "设备铺设": "",
  "销售数据": "",
  "请选择无效原因": ""
}